import { makeVar } from '@apollo/client'

export const userSettingsDialogVisibleVar = makeVar<boolean>(false)
